import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { AdminState } from './state';

const defaultState: AdminState = {
  users: [],
  userResult: 0,
  userError: null,
  userPasswordError: null,
  apps: [],
  lastId: 0,
  selectedUsers: [],
  selectedApps: [],
  countryClusters: [],
  selectedCountries: '',
  partners: [],
  partnersByApp: [],
  appsByPartner: [],
};

export const adminModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
